import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import {Popconfirm, message, Popover, Button} from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fontawesome from '@fortawesome/fontawesome';
import { faEye, faTrash } from '@fortawesome/fontawesome-free-solid';

//action imports
import { fetchMoreScheduledAnnouncements, pushScheduledAnnouncement, deleteAnnouncement } from "../../../actions/AnnouncementsActions";

//component imports
import {Spinner} from "../../common/Spinner";

fontawesome.library.add(faEye, faTrash);

class ViewScheduledAnnouncements extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scheduledAnnouncements: this.props.scheduledAnnouncements,
            scheduledAnnouncementsLoading: this.props.scheduledAnnouncementsLoading,
            moreScheduledAnnouncementsLoading: this.props.moreScheduledAnnouncementsLoading,
            startAt: this.props.startAt
        };

        this.onMoreScheduledAnnouncementsPress = this.onMoreScheduledAnnouncementsPress.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps !== this.props) {
            this.setState({
                scheduledAnnouncements: nextProps.scheduledAnnouncements,
                scheduledAnnouncementsLoading: nextProps.scheduledAnnouncementsLoading,
                moreScheduledAnnouncementsLoading: nextProps.moreScheduledAnnouncementsLoading,
                startAt: nextProps.startAt
            })
        }
    }

    onDeleteScheduledAnnouncement(announcement) {
        this.props.deleteAnnouncement({ announcement, path: "scheduled" });
    }

    onCancel() {
        message.info("Deletion is canceled").then();
    }

    onMoreScheduledAnnouncementsPress() {
        const { startAt } = this.state;

        //add startAt number
        const addedStartAt = startAt + 20;

        this.props.fetchMoreScheduledAnnouncements({ startAt: addedStartAt });

    }

    renderMoreButton() {
        const { moreScheduledAnnouncementsLoading } = this.state;

        if (moreScheduledAnnouncementsLoading) {
            return <Spinner/>
        } else {
            return (
                <div className={"newCustomerButtonBox"}>
                    <Button onCllick={() => this.onMoreScheduledAnnouncementsPress()}>More</Button>
                </div>
            );
        }
    }

    renderScheduledAnnouncements() {
        const { scheduledAnnouncements, scheduledAnnouncementsLoading } = this.state;

        if(scheduledAnnouncementsLoading) {
            return <Spinner/>
        } else {
            if (scheduledAnnouncements.length !== 0) {
                const sortedAnnouncements = _.orderBy(scheduledAnnouncements, ['announcementDate'], ['desc']);
                return (
                    <div>
                        {
                            sortedAnnouncements.map(announcement => {
                                let seconds;
                                announcement.announcementDate.seconds ? seconds =  announcement.announcementDate.seconds : seconds =  announcement.announcementDate._seconds;
                                const dateObj = moment.unix(seconds);
                                const dateString = dateObj.format("Do MMM YYYY | HH:mm");

                                const description = (
                                    <div>
                                        <p>{announcement.announcementDescription}</p>
                                    </div>
                                );
                                return (
                                    <div key={announcement.announcementID} className={"boxCard"}>
                                        <div className={"announcementBox"}>
                                            <div>
                                                <p style={{ fontFamily: "myriadBold", color: "darkgray"}}>{dateString}</p>
                                                <h2>{announcement.announcementTitle}</h2>
                                                <Popover content={description} title="Title">
                                                    <Button type="primary">View Description</Button>
                                                </Popover>
                                            </div>
                                            <div style={{ display: "flex", backgroundColor: "#46494A", textAlign: 'center', justifyContent: "center", alignItems: "center" }}>
                                                {
                                                    announcement.announcementFile ?
                                                        <div className={"clickable"} onClick={() => window.open(`${announcement.announcementFile}`,'name','width=700,height=600')}><FontAwesomeIcon icon="eye" color="#ffffff" size="1x" /></div>
                                                        : <p style={{ marginTop: '1.5rem'}}>No file</p>
                                                }
                                            </div>
                                            <Popconfirm
                                                title="Are you sure to delete this alert?"
                                                onConfirm={() => this.onDeleteAnnouncement(announcement)}
                                                onCancel={() => this.onCancel()}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <div className={"clickable"} style={{textAlign: 'center', justifyContent: "center", alignItems: "center", backgroundColor: "#D7373B"}}><FontAwesomeIcon icon={"trash"} color={"#ffffff"} size={"1x"} className={"trashIcon2"}/></div>
                                            </Popconfirm>
                                        </div>
                                    </div>
                                );
                            })
                        }

                        { this.renderMoreButton() }
                    </div>
                );
            } else {
                return <h3 style={{ fontFamily: "myriadBold", fontSize: 20 }}>No scheduled announcements posted yet</h3>
            }
        }
    }

    render() {
        return(
            <div>
                <p style={{ fontFamily: "myriadBold", fontSize: 20 }}>View Scheduled Announcements</p>
                { this.renderScheduledAnnouncements() }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { scheduledAnnouncements, scheduledAnnouncementsLoading, moreScheduledAnnouncementsLoading, startAt } = state.announcements;

    return {
        scheduledAnnouncements,
        scheduledAnnouncementsLoading,
        moreScheduledAnnouncementsLoading,
        startAt
    }
}

export default withRouter(connect(mapStateToProps, { fetchMoreScheduledAnnouncements, pushScheduledAnnouncement, deleteAnnouncement })(ViewScheduledAnnouncements));